import Pin from './pin';
/**
 * Office Map
 */
class OfficeMap {
  constructor(el, options) {
    this.el = el;
    this.pins = [];
    this.pinElements = document.querySelectorAll(options.pins);
    this.metaSelectors = options.meta;
    this.metaElements = {};
    this.metaButton = this.getElement(options.button);
    this.active = null;
    this.initPins();
    this.initMeta();
    this.initSelect();
    this.setActive(this.pins[0]);
  }

  // Build Pins
  initPins() {
    for ( var i = 0; i < this.pinElements.length; i++ ) {
      this.pins.push(new Pin(this.pinElements[i], this));
    }
  }

  // Store elements
  initMeta() {
    for ( var key in this.metaSelectors ) {
      this.metaElements[key] = this.getElement(this.metaSelectors[key]);
    }
  }

  // Mobile select
  initSelect() {
    this.select = document.querySelector('[data-js=officemap-select]');
    this.select.addEventListener('change', (e) => {
      this.pinElements[this.select.value].click();
    });
  }

  // Get Child Elements
  getElement(selector) {
    return this.el.querySelector(selector);
  }

  // Update active office
  setActive(pin) {
    this.clearActive();
    this.active = pin;
    this.active.toggle(1);

    if (this.metaButton) {
      if ( pin.label === 'UK' ) {
        this.metaButton.classList.add('is-hidden');
      } else {
        this.metaButton.classList.remove('is-hidden');
        this.metaButton.setAttribute('href', pin.data.website);
      }
    }

    for ( var key in this.metaElements ) {
      if ( this.metaElements[key] ) {
        let labelElement = this.metaElements[key].previousElementSibling;
        if ( labelElement ) {
          if ( pin.data[key] === null ) {
            labelElement.classList.add('is-hidden');
          } else {
            labelElement.classList.remove('is-hidden');
          }
        }

        this.metaElements[key].classList.add('is-hidden');
        setTimeout(this.metaFadeIn.bind(this, key, pin), 200);
      }
    }
  }

  clearActive() {
    if ( this.active ) {
      this.active.toggle(0);
      this.active = null;
    }
  }

  metaFadeIn(key, pin) {
    if ( typeof pin.data[key] == "object" && pin.data[key] !== null ) {
      this.metaElements[key].previousElementSibling.innerHTML = pin.data[key].label;
      this.metaElements[key].innerHTML = pin.data[key].value;
    } else {
      this.metaElements[key].innerHTML = pin.data[key];
    }
    this.metaElements[key].classList.remove('is-hidden');
  }
}

export default OfficeMap;



// WEBPACK FOOTER //
// ./scripts/components/officemap.js